/* =========================================================
   EYESHELLS: Split engo-scripts.js -> engo-core.js (global)
   - Keeps header/search fallback, cart links and shared sliders
   - Floating chat/back-to-top integration is owned by es-floating-controls.js
   - Adds small global initializers (popup recommended slider)
   ========================================================= */

/*
  Legacy swatch click handler removed.
  (It set BOTH primary+secondary images to the same URL, which made hover swap look "broken".)
  Swatch behavior is owned by assets/es-swatch.js and the maintained product-card runtime.
*/

/* ES PERF 1503: Recently Viewed runtime removed.
   The current theme contains no .engoj-recently-wrapper or .js_prod_recent markup,
   so its cookie reads, product AJAX requests and Slick initializer had no target. */

jQuery(document).ready(function($) {
  "use strict";

  
  
  function promo(){
    $('.close_promo_topbar').off('click.esPromoTopbar').on('click.esPromoTopbar', function(e){
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
      $('.promo_topbar').addClass('active');
    });
  }

  function search(){
    $('.js-search-destop').off('click.esDesktopSearchOpen').on('click.esDesktopSearchOpen', function() {
      $('.js-box-search').addClass('active');
      $('.bg_search_box').addClass('active');
      $('body').addClass('activedestop');
    });
    $('.js-drawer-close').off('click.esDesktopSearchClose').on('click.esDesktopSearchClose', function() {
      $('.js-box-search').removeClass('active');
      $('.bg_search_box').removeClass('active');
      $('body').removeClass('activedestop');
    });
    $('.bg_search_box').off('click.esDesktopSearchBackdrop').on('click.esDesktopSearchBackdrop', function() {
      $('.js-box-search').removeClass('active');
      $('.bg_search_box').removeClass('active');
      $('body').removeClass('activedestop');
    });
  }

/* Eyeshells: allow ESC to close open popups (quickview / filters) */
$(document)
  .off('keyup.eyeshellsEscClose')
  .on('keyup.eyeshellsEscClose', function(e) {
    var key = e.key || e.keyCode;
    if (key !== 'Escape' && key !== 'Esc' && key !== 27) return;

    // 1) Quickview modal
    if ($('.quickview-product').hasClass('active') || $('.tshopify-popup').hasClass('active')) {
      try {
        if (typeof window.hidePopup === 'function') {
          window.hidePopup('.tshopify-popup');
          window.hidePopup('.quickview-product');
        } else {
          $('.quickview-product').addClass('es-qv-closing');
          $('.tshopify-popup, .quickview-product').removeClass('active');
          setTimeout(function(){ $('.quickview-product').removeClass('es-qv-closing'); }, 220);
        }
      } catch (_esQvEscClose) {
        $('.quickview-product').addClass('es-qv-closing');
        $('.tshopify-popup, .quickview-product').removeClass('active');
        setTimeout(function(){ $('.quickview-product').removeClass('es-qv-closing'); }, 220);
      }
      setTimeout(function(){ $('.loading').removeClass('loaded-content'); }, 300);
      return;
    }

    // 2) Filter drawer
    if ($('.filter-to-left').hasClass('active')) {
      $('.filter-to-left').removeClass('active');
      $('.overlay-filter').removeClass('active');
      return;
    }
  });




  function esRafThrottle(fn) {
    var ticking = false;
    return function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        ticking = false;
        fn();
      });
    };
  }

  function mobilescroll() {
    $(window).off('scroll.esMobileMenuState resize.esMobileMenuState');
    $('.es-mobile-header-sticky-spacer').remove();
    $('.menu_moblie').removeClass('menu_mobilescroll').removeAttr('data-es-sticky-natural-height');
  }

  // Mobile menu interaction is owned by assets/es-mobilemenu.js.
  // Keep only the legacy sticky-class cleanup below.


    

  // Floating controls are initialized by assets/es-floating-controls.js.
  function jsmenu_fullwidth(){
    var $header = $('.js_height_hd');
    var $fullWidth = $('.js-full-width');
    if (!$header.length || !$fullWidth.length) return;

    var update = esRafThrottle(function() {
      var top = $header.offset();
      var height = $header.outerHeight() || 0;
      if (!top) return;
      $fullWidth.css({'position':'fixed','left':'0','right':'0','width':'100%'});
      if ((window.pageYOffset || document.documentElement.scrollTop || 0) >= height){
        $fullWidth.css({'top' : height - 15 });
      }
      else{
        $fullWidth.css({'top' : top.top + height - 15 });
      }
    });

    $(window).off('scroll.esFullWidthMenu resize.esFullWidthMenu').on('scroll.esFullWidthMenu resize.esFullWidthMenu', update);
    update();
  }
  
  
  
  jsmenu_fullwidth();
  mobilescroll();
  search();
  promo();

});

      
	      // (Removed) Ajax add-to-cart popup no longer requires a terms checkbox.

      ///////ZOOM IMAGE

      


(function($){
  $(function(){
    "use strict";
    // Popup recommended products slider (appears in ajax add-to-cart popup).
    function productnewh5(){
      var $el = $('.slick_product_new-h5');
      if (!$el.length) return;
      if ($el.hasClass('slick-initialized')) return;
      if (!$el.slick) return;

      $el.slick({
        arrows: true,
        infinite: false,
        dots: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
        nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: 3, arrows: true, infinite: false, dots: false } },
          { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 2 } },
          { breakpoint: 600,  settings: { slidesToShow: 2, arrows: true, infinite: false, dots: false } }
        ]
      });
    }

    productnewh5();
  });
})(window.jQuery);
